import React from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import './css/index.css';
import './css/animate.css';
import './css/carousel.min.css';
import AppRouter from './routes/AppRouter';
import * as serviceWorker from './serviceWorker';
import { createRoot, hydrateRoot } from 'react-dom/client';

import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Safely patch ResizeObserver and error listener to prevent benign "ResizeObserver loop" warnings
if (typeof window !== 'undefined') {
  if (window.ResizeObserver) {
    const OriginalResizeObserver = window.ResizeObserver;
    window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
      constructor(callback) {
        super((entries, observer) => {
          window.requestAnimationFrame(() => {
            try {
              callback(entries, observer);
            } catch (err) {
              if (!err || !err.message || !err.message.includes('ResizeObserver')) {
                throw err;
              }
            }
          });
        });
      }
    };
  }

  const suppressResizeObserverError = (e) => {
    if (
      e &&
      (e.message?.includes('ResizeObserver loop') ||
       e.error?.message?.includes('ResizeObserver loop'))
    ) {
      e.stopImmediatePropagation();
      e.preventDefault();
      return true;
    }
  };

  window.addEventListener('error', suppressResizeObserverError);
  window.addEventListener('unhandledrejection', (e) => {
    if (e.reason?.message?.includes('ResizeObserver loop')) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  });
}

// Language detection from URL path or localStorage (Armenian is default)
let initialLng = 'hy';
if (typeof window !== 'undefined') {
  const path = window.location.pathname;
  if (path.startsWith('/en') || path.startsWith('/en/')) {
    initialLng = 'en';
  } else if (path.startsWith('/ru') || path.startsWith('/ru/')) {
    initialLng = 'ru';
  } else {
    const saved = localStorage.getItem('i18nextLng');
    if (saved === 'en' || saved === 'ru' || saved === 'hy') {
      initialLng = saved;
    }
  }
}

i18n
  .use(initReactI18next)
  .init({
    lng: initialLng,
    fallbackLng: "hy",
    interpolation: {
      escapeValue: false
    },
    resources: {
      hy: {
        translation: require("./locales/hy/translation.json")
      },
      en: {
        translation: require("./locales/en/translation.json")
      },
      ru: {
        translation: require("./locales/ru/translation.json")
      }
    }
  });

if (typeof document !== 'undefined') {
  document.documentElement.lang = initialLng;
  i18n.on('languageChanged', (lng) => {
    document.documentElement.lang = lng;
    try {
      localStorage.setItem('i18nextLng', lng);
    } catch (e) {}
  });
}

const rootElement = document.getElementById("root");
if (rootElement.hasChildNodes()) {
  const root = hydrateRoot(rootElement);
  root.render(<AppRouter />);
} else {
  const root = createRoot(rootElement);
  root.render(<AppRouter />);
}

serviceWorker.unregister();
